import { GlobalSettingsControl } from "@/components/common/GlobalSettingsControl";
import { DriverRouteList } from "./DriverRouteList";
import { useDriverApp } from "./useDriverApp";

export function DriverAppShell() {
  const app = useDriverApp();

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-100">
      <header className="sticky top-0 z-20 border-b border-slate-200 bg-white/95 px-4 py-3 backdrop-blur dark:border-slate-800 dark:bg-slate-900/95">
        <div className="mx-auto flex max-w-lg items-center justify-between gap-3">
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-indigo-600 dark:text-indigo-400">
              Driver
            </p>
            <h1 className="text-lg font-bold leading-tight">Today&apos;s stops</h1>
          </div>
          <div className="flex items-center gap-2">
            <span
              className={`h-2.5 w-2.5 rounded-full ${app.offline ? "bg-amber-500" : "bg-emerald-500"}`}
              title={app.offline ? "Offline" : "Online"}
            />
            <button
              type="button"
              onClick={() => void app.refresh()}
              disabled={app.syncing}
              className="rounded-lg border border-slate-300 px-3 py-1.5 text-xs font-semibold disabled:opacity-50 dark:border-slate-600"
            >
              {app.syncing ? "Syncing…" : "Sync now"}
            </button>
            <GlobalSettingsControl />
          </div>
        </div>
        {app.fromCache && app.offline ? (
          <p className="mx-auto mt-2 max-w-lg text-xs text-amber-700 dark:text-amber-300">
            Showing cached routes — connect to sync.
          </p>
        ) : null}
        {app.toast ? (
          <p className="mx-auto mt-2 max-w-lg text-xs text-amber-800 dark:text-amber-200">{app.toast}</p>
        ) : null}
        {app.error ? (
          <p className="mx-auto mt-2 max-w-lg text-xs text-rose-700 dark:text-rose-300">{app.error}</p>
        ) : null}
      </header>

      <main className="mx-auto max-w-lg px-4 py-4 pb-10">
        {app.loading ? (
          <p className="text-sm text-slate-600 dark:text-slate-400">Loading your routes…</p>
        ) : app.manifest ? (
          <DriverRouteList manifest={app.manifest} onStamp={app.stamp} stampingStopId={app.stampingStopId} />
        ) : (
          <p className="text-sm text-slate-600 dark:text-slate-400">No route data available.</p>
        )}
      </main>
    </div>
  );
}
